import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { BridalServices } from './pages/BridalServices';
import { BeautyServices } from './pages/BeautyServices';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/about" element={<About data-id="element-6" />} data-id="element-5" />
          <Route path="/bridal-services" element={<BridalServices data-id="element-8" />} data-id="element-7" />
          <Route path="/beauty-services" element={<BeautyServices data-id="element-10" />} data-id="element-9" />
          <Route path="/contact" element={<Contact data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}